import { FC, memo } from "react";
import ChatContent from "../ChatContent";
import ChatInput from "../ChatInput";

const Chat: FC = () => (
  <>
    <ChatContent />
    <ChatInput />
  </>
);

export default memo(Chat);